//#region IMPORTS
import { setInstoreTemplatePageNumber } from "../../features/instoreTemplates/instoreTemplatesSlice";
import { InstoreTemplate } from "../../models/instoreTemplate";
import { useAppDispatch } from "../../store/configureStore";
import { MetaData } from "../../models/pagination";
import InstoreTemplatesTableHeader from "./InstoreTemplatesTableHeader";
import InstoreTemplatesTableRow from "./InstoreTemplatesTableRow";
import MainTable from "../_layout/MainTable";
//#endregion

//#region INTERFACE
interface Props {
  editOrCopyHandler: (item: InstoreTemplate, copy: boolean) => void;
  deleteHandler: (item: InstoreTemplate) => void;
  itemsLoaded: boolean;
  metaData?: MetaData;
  loading?: boolean;
  isAdmin?: boolean;
  items: InstoreTemplate[];
  hide?: boolean;
}
//#endregion

export default function InstoreTemplatesTable({
  editOrCopyHandler,
  deleteHandler,
  itemsLoaded,
  metaData,
  loading = false,
  isAdmin = false,
  items,
  hide = false,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region RENDER
  return (
    <MainTable
      itemsLoaded={itemsLoaded}
      metaData={metaData}
      onPageChangeHandler={(page: number) =>
        dispatch(setInstoreTemplatePageNumber({ page: page }))
      }
      header={<InstoreTemplatesTableHeader />}
      hide={hide}
    >
      {items.map((instoreTemplate) => (
        <InstoreTemplatesTableRow
          editOrCopyHandler={(copy: boolean) =>
            editOrCopyHandler(instoreTemplate, copy)
          }
          instoreTemplate={instoreTemplate}
          deleteHandler={() => deleteHandler(instoreTemplate)}
          loading={loading}
          isAdmin={isAdmin}
          key={instoreTemplate.id}
        />
      ))}
    </MainTable>
  );
}
